import React from "react";
import { Program } from "@models/ISchema";
import i18n from "@config/i18n";
import css from "../components/Preferences/preferences.module.scss";

export const getProgramSelectorLabel = (program: Program) => {
  if (!program) return "";

  return (
    <div className={css.programSelector}>
      <h5 className={css.programSelector_topLabel}>
        {program?.code} <b>{program?.name}</b>
      </h5>
      <p className={css.programSelector_bottomLabel}>
        {i18n.t("selectors.course-selector.campus")}: <b>{program?.campus?.name}</b> |{" "}
        {i18n.t("selectors.course-selector.school")}: <b>{program?.department?.name}</b> |{" "}
        {i18n.t("selectors.course-selector.modality")}: <b>{program?.modality?.name}</b> |{" "}
        {i18n.t("selectors.course-selector.shift")}: <b>{program?.shift?.name}</b>
      </p>
    </div>
  );
};
